module.exports = __webpack_public_path__ + "static/developments-c15595617eefb3750a888af38dee0a2b.mp4";